function getPrefferedLanguage () {
  let prefferedLanguage = 'pl';
  let savedLanguage = window.localStorage.getItem('headwear-crm-ui-language');

  if (savedLanguage) {
    if (parseInt(savedLanguage, 10) === 1 || parseInt(savedLanguage, 10) === 2) {
      prefferedLanguage = parseInt(savedLanguage, 10) === 1 ? 'pl' : 'en';
    }
  } else if (navigator && navigator.language) {
    prefferedLanguage = navigator.language;
    prefferedLanguage = prefferedLanguage.split('-');
    prefferedLanguage = prefferedLanguage[0];

    if (prefferedLanguage !== 'pl' && prefferedLanguage !== 'en') {
      prefferedLanguage = 'pl';
    }
  }

  return prefferedLanguage;
}

export default getPrefferedLanguage;
